import { Globe, Database, KeyRound, CheckCircle2 } from "lucide-react";
import { useAzure } from "@/context/AzureContext";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "@/components/ui/table";

export default function AppServices() {
  const { state } = useAzure();
  const sites = (state?.resources || []).filter((r) => r.type === "Microsoft.Web/sites");
  return (
    <div data-testid="az-app-services">
      <div className="flex items-center gap-2 border-b border-border pb-3 mb-3">
        <Globe className="h-5 w-5 text-[#0078d4]" /><h2 className="font-semibold">App Services</h2>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {sites.map((s) => (
          <div key={s.id} className="border border-border rounded-md p-4" data-testid={`az-app-${s.name}`}>
            <div className="flex items-center justify-between">
              <div className="font-medium text-[#0078d4]">{s.properties.display_name || s.name}</div>
              <span className={`text-xs font-medium flex items-center gap-1 ${s.properties.state === "Running" ? "text-emerald-600" : "text-muted-foreground"}`}>
                <CheckCircle2 className="h-3.5 w-3.5" /> {s.properties.state}
              </span>
            </div>
            <a href={`https://${s.properties.default_hostname}`} className="text-xs text-[#0078d4] hover:underline" onClick={(e) => e.preventDefault()}>{s.properties.default_hostname}</a>
            <div className="mt-3 space-y-1.5 text-sm">
              <div className="flex justify-between border-b border-border/50 py-1"><span className="text-muted-foreground">Runtime</span><span>{s.properties.runtime}</span></div>
              <div className="flex justify-between border-b border-border/50 py-1"><span className="text-muted-foreground flex items-center gap-1"><Database className="h-3.5 w-3.5" /> Database</span><span>{s.properties.linked_database}</span></div>
              <div className="flex justify-between border-b border-border/50 py-1"><span className="text-muted-foreground flex items-center gap-1"><KeyRound className="h-3.5 w-3.5" /> Managed identity</span><span>{s.properties.managed_identity || "None"}</span></div>
              <div className="flex justify-between py-1"><span className="text-muted-foreground">Health</span><span className="text-emerald-600">{s.properties.health}</span></div>
            </div>
          </div>
        ))}
        {sites.length === 0 && <div className="text-sm text-muted-foreground">No app services.</div>}
      </div>
    </div>
  );
}
